import { Navigate, useLocation } from 'react-router';
import { useSession } from "./SessionContext";
import { JSX } from "react";

export const RequireAuth = ({ children, requiredRole }: { children: JSX.Element; requiredRole?: string }) => {
  const { user, loading, isLoggingOut } = useSession();
  const location = useLocation();

  if (loading) {
      return (
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          height: '100vh',
          fontSize: '1.2rem',
          color: '#666'
        }}>
          Checking session...
        </div>
      );
  }

  if (!user && !isLoggingOut) {
    return (
      <Navigate
        to={`/?redirect=${encodeURIComponent(location.pathname + location.search + location.hash)}`}
        replace
      />
    );
  }

  if (requiredRole && user?.user_role !== requiredRole) {
    return <Navigate to="/" replace />;
  }

  return children;
};